import { render } from "./MailComposer.vue?vue&type=template&id=39c7ed9a"
import script from "./MailComposer.vue?vue&type=script&lang=js"
export * from "./MailComposer.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__